// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"0e68e97d","633":"5c4e3974","816":"01e062fc"}[chunkId] + ".chunk.js";
};